import { nanoid } from "nanoid";

export const id = () => nanoid();
